"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonTypesConversions = void 0;
const EventJSONModel_1 = require("src/hello_assets/src/components/model/common/event/EventJSONModel");
const QueryEventVariantJSONModel_1 = require("src/hello_assets/src/components/model/common/queryEventVariant/QueryEventVariantJSONModel");
const typescriptAddons_1 = require("src/hello_assets/src/util/typescriptAddons");
const QueryEventVariantsJSONModel_1 = require("src/hello_assets/src/components/model/common/queryEventVariant/QueryEventVariantsJSONModel");
const lodash_1 = __importDefault(require("lodash"));
exports.CommonTypesConversions = {
    periodType: {
        fromLastNDays: (value) => ({ last: value })
    },
    event: {
        eventNameToEventQuery: (value) => ({ eventDescription: { name: value } }),
        eventQueryToEventJSONModel: (value) => new EventJSONModel_1.EventJSONModel({ name: value.eventDescription.name })
    },
    queryEventVariant: {
        queryEventVariantToQueryEventVariantComposite: (queryEventVariant) => {
            if (queryEventVariant) {
                if ((0, typescriptAddons_1.hasOwnProperty)(queryEventVariant, "event")) {
                    return { type: "event", event: exports.CommonTypesConversions.event.eventQueryToEventJSONModel(queryEventVariant.event) };
                }
                else if ((0, typescriptAddons_1.hasOwnProperty)(queryEventVariant, "newUser")) {
                    return { type: "newUser" };
                }
                else if ((0, typescriptAddons_1.hasOwnProperty)(queryEventVariant, "anyEvent")) {
                    return { type: "anyEvent" };
                }
                else if ((0, typescriptAddons_1.hasOwnProperty)(queryEventVariant, "session")) {
                    return { type: "session" };
                }
            }
        },
        queryEventVariantCompositeToQueryEventVariant: (queryEventVariant) => {
            if (queryEventVariant) {
                switch (queryEventVariant.type) {
                    case "newUser":
                        return { "newUser": null };
                    case "event": {
                        const eventQuery = queryEventVariant.event.toEventQuery();
                        if (eventQuery) {
                            return { "event": eventQuery };
                        }
                        break;
                    }
                    case "session":
                        return { "session": null };
                    case "anyEvent":
                        return { "anyEvent": null };
                }
            }
        },
        eventNameToQueryEventVariant: (eventName) => {
            const eventQuery = exports.CommonTypesConversions.event.eventNameToEventQuery(eventName);
            return { event: eventQuery };
        },
        eventNameToQueryEventVariantComposite: (eventName) => {
            const queryEventVariant = exports.CommonTypesConversions.queryEventVariant.eventNameToQueryEventVariant(eventName);
            const result = exports.CommonTypesConversions.queryEventVariant.queryEventVariantToQueryEventVariantComposite(queryEventVariant);
            return result;
        }
    },
    queryEventVariants: {
        queryEventVariantsJSONModelFromQueryEventVariant: (value) => {
            const jsonModel = new QueryEventVariantsJSONModel_1.QueryEventVariantsJSONModel();
            lodash_1.default.each(value, v => {
                const queryEventVariantJSONModel = new QueryEventVariantJSONModel_1.QueryEventVariantJSONModel();
                queryEventVariantJSONModel.setValueAsQueryEventVariant(v);
                jsonModel.addQueryEventVariantJSONModel(queryEventVariantJSONModel);
            });
            return jsonModel;
        }
    },
    retentionType: {
        retentionTypeTypeToRetentionType: (value) => value === "nDay" ? { nDay: {} } : value === "nWeek" ? { nWeek: {} } : { nMonth: {} },
        retentionTypeToRetentionTypeType: (value) => {
            if ((0, typescriptAddons_1.hasOwnProperty)(value, "nDay")) {
                return "nDay";
            }
            else if ((0, typescriptAddons_1.hasOwnProperty)(value, "nWeek")) {
                return "nWeek";
            }
            else {
                return "nMonth";
            }
        }
    }
};
